import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { DprProgressWithoutTargetReport } from '@report/models';
import { StaticMessage } from '@shared/enums';
import { DprProgressWithoutTarget } from '@shared/models/dpr';
import {
  ProgressWithoutTarget,
  ProgressWithoutTargetTerminology,
  SubprojectConfiguration,
} from '@shared/models/project-setup';

@Component({
  selector: 'app-report-progress-without-target',
  templateUrl: './report-progress-without-target.component.html',
  styleUrls: ['./report-progress-without-target.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportProgressWithoutTargetComponent implements OnInit {
  @Input({ required: true }) progressWithoutTarget: ProgressWithoutTarget;
  @Input({ required: true }) dprProgressWithoutTarget: DprProgressWithoutTarget;
  @Input({ required: true }) subprojectConfiguration: SubprojectConfiguration;

  progressWithoutTargetReport: DprProgressWithoutTargetReport[] = [];

  StaticMessage = StaticMessage;

  get progressWithoutTargetTerminology(): ProgressWithoutTargetTerminology {
    return this.progressWithoutTarget.progressWithoutTargetTerminology;
  }

  ngOnInit(): void {
    this.progressWithoutTarget?.progressWithoutTargetItems.forEach(
      (progressWithoutTarget) => {
        const detail = (
          this.dprProgressWithoutTarget.dprProgressWithoutTargetDetails || []
        ).find((x) => x.progressWithoutTargetId === progressWithoutTarget.id);

        this.progressWithoutTargetReport.push({
          name: progressWithoutTarget.name,
          clearedToday: detail.clearedToday?.toFixed(2) ?? '-',
          clearedTotal: detail.clearedTotal?.toFixed(2) ?? '-',
          comment: detail.comment ?? '-',
        });
      }
    );
  }
}
